export const STRUCTURE = {
  STRUCTURE_SUBORDINATION: 'STRUCTURE_SUBORDINATION',
  STRUCTURE_SUBORDINATED_AGENTS: 'STRUCTURE_SUBORDINATED_AGENTS',
};
